import { render } from "./accaModal.vue?vue&type=template&id=08d648ae&scoped=true"
import script from "./accaModal.vue?vue&type=script&lang=js"
export * from "./accaModal.vue?vue&type=script&lang=js"

import "./accaModal.vue?vue&type=style&index=0&id=08d648ae&lang=scss&scoped=true"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d648ae"]])

export default __exports__